import React from "react";
import { ChevronLeft, ArrowRight } from "lucide-react";
import { Button } from "components";
import StepIndicator from "../StepIndicator";
import ProgressBar from "../ProgressBar";
import "./styles.css";

export interface StepperLayoutProps {
  currentStep: number;
  totalSteps: number;
  stepTitle: string;
  stepSubtitle?: string;
  onBack: () => void;
  onNext: () => void;
  onPrevious?: () => void;
  canGoNext?: boolean;
  canGoPrevious?: boolean;
  nextButtonText?: string;
  previousButtonText?: string;
  showBackButton?: boolean;
  children: React.ReactNode;
}

const StepperLayout: React.FC<StepperLayoutProps> = ({
  currentStep,
  totalSteps,
  stepTitle,
  stepSubtitle,
  onBack,
  onNext,
  onPrevious,
  canGoNext = true,
  canGoPrevious = true,
  nextButtonText = "Next",
  previousButtonText = "Back",
  showBackButton = true,
  children,
}) => {
  const handlePrevious = () => {
    if (onPrevious) {
      onPrevious();
    } else if (currentStep > 1) {
      // Default behavior: go to previous step
      onBack();
    }
  };

  return (
    <div className="stepper-layout">
      <div className="stepper-layout-header">
        {showBackButton && (
          <button className="stepper-layout-back-btn" onClick={onBack} aria-label="Back">
            <ChevronLeft size={20} />
          </button>
        )}
      </div>

      <div className="stepper-layout-content">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <StepIndicator currentStep={currentStep} totalSteps={totalSteps} title={stepTitle} subtitle={stepSubtitle} />

        <div className="stepper-layout-step-content">{children}</div>
      </div>

      <div className="stepper-layout-footer">
        <Button variant="ghost" size="medium" onClick={handlePrevious} disabled={!canGoPrevious || currentStep === 1}>
          {previousButtonText}
        </Button>
        <Button
          variant="primary"
          size="medium"
          icon={ArrowRight}
          iconPosition="right"
          onClick={onNext}
          disabled={!canGoNext}
        >
          {nextButtonText}
        </Button>
      </div>
    </div>
  );
};

export default StepperLayout;
